import { Link } from "react-router-dom";

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, center = false }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} mb-10 lg:mb-14`}>
    {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
    <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>
    )}
  </div>
);

export const QuotationCTA = () => (
  <section className="relative overflow-hidden bg-[#0A1128]" data-testid="quotation-cta-band">
    <div className="absolute inset-0 hero-grid-overlay opacity-40" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 flex flex-col lg:flex-row items-center justify-between gap-8">
      <div className="max-w-2xl">
        <p className="eyebrow mb-3">Start Your Project</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight">
          Ready to design, renovate or build? Request your quotation.
        </h2>
        <p className="mt-4 text-slate-300">
          Tell us about your project and our team will prepare a transparent, itemised quotation.
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-4 shrink-0">
        <Link
          to="/request-quotation"
          data-testid="cta-request-quotation"
          className="px-7 py-3.5 rounded-full bg-gradient-to-r from-[#B87333] to-[#D97706] text-[#0A1128] font-bold hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#B87333]/30 transition-all text-center"
        >
          Request a Quotation
        </Link>
        <Link
          to="/contact"
          data-testid="cta-contact"
          className="px-7 py-3.5 rounded-full border border-white/25 text-white font-semibold hover:bg-white/10 transition-colors text-center"
        >
          Contact Us
        </Link>
      </div>
    </div>
  </section>
);
